export default __webpack_public_path__ + "static/media/info.65a9c1fc.svg";